import { useState } from "react";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { useFetchCompaniesQuery } from "@services";
import { setSelectedCompanyInStorage } from "@/services/global-storage";
import { ICompany } from "@/types";

import { useTypedSelector } from "@/hooks";
import CompanySelectCarousel from "@components/caurosel";
import CompanyList from "@/components/List/company-list";
import { BiChevronRight } from "react-icons/bi";
import "./apps.less";

export interface CompanyListType {
  name: string;
  desc: string;
  continents: string;
  icon: string;
}

const Apps = () => {
  const [
    page,
    // setPage
  ] = useState(1);
  const selectedApp = useTypedSelector(state => state.selected_app);
  const [searchString, setSearchString] = useState<string>("");
  const [selectedCompany, setselectedCompany] = useState<string | null>(null);

  const { data: companiesData, isLoading: isFetching } =
    useFetchCompaniesQuery(page);
  const { data } = companiesData || {};
  const onPressNext = () => {
    window.open(selectedApp.applicationLink, "_self");
    // window.open("http://localhost:3000", "_self");
  };

  let handleCompanySelect = (companyId: any) => {
    const findCompany = data?.find((item: any) => item.id == companyId);
    if (findCompany) {
      setselectedCompany(findCompany);
      setSelectedCompanyInStorage(findCompany);
      onPressNext();
    }
  };
  return (
    <div className="ApplicationSelector  w-full px-12">
      {isFetching ? (
        <div
          style={{ height: "650px" }}
          className="flex justify-center items-center "
        >
          <LoadingOutlined className="spinner " style={{ fontSize: "80px" }} />
        </div>
      ) : (
        <main className="min-h-screen bg-background flex items-center justify-center p-4">
          <div className="w-full  ">
            <div className="mb-12">
              <h1 className="text-4xl font-semibold text-foreground text-themeBlue mb-3">
                Select Company
              </h1>
              <p className="text-base text-muted-foreground font-light">
                Choose a company to access and manage its operations
              </p>
            </div>

            <CompanyList
              companiesList={data && data}
              onSelectCompany={setselectedCompany}
              selectedCompany={selectedCompany}
            />

            {selectedCompany && (
              <div className="mt-8 flex gap-2  bottom-2 sticky">
                <button
                  onClick={() => handleCompanySelect(selectedCompany)}
                  className="flex-1 bg-themeBlue text-white px-5 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
                >
                  {data?.find((item: any) => item?.id == selectedCompany)?.name}
                  <BiChevronRight className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>
        </main>
      )}
    </div>
  );
};

export default Apps;
